import { EFilterEntity, IFilterSchemeExtended } from '../common';

export const dexPairConnectWalletsFiltersScheme = (): // pair: IDexPair,
Record<string, IFilterSchemeExtended> => ({
  wallets: {
    type: EFilterEntity.multi_search,
    label: 'Wallet addresses',
    name: 'wallets',
    field: 'wallets',
    single: true,
  },
});
